import { STYLE_SETTING_CLASS_NAME_PREFIX } from '@constants'
import { DisplayRule, DisplayRuleScriptData } from '@types'

import { executeCode } from './executeCode'

type Props = {
  scriptData: DisplayRuleScriptData
  displayRule?: DisplayRule
  value?: string
  useDisplayRule?: boolean
  classNamePrefix?: string
}

export const convertDisplayRuleToStyleSettingClassName = (data: Props): string | undefined => {
  const {
    scriptData = {},
    displayRule,
    value,
    useDisplayRule,
    classNamePrefix = STYLE_SETTING_CLASS_NAME_PREFIX,
  } = data

  const isNotUseDisplayRule =
    !useDisplayRule ||
    !displayRule ||
    (displayRule.isJs &&
      (!displayRule.jsSetting?.styleSettingScript || !displayRule.jsSetting?.styleSettings?.length))

  if (isNotUseDisplayRule) {
    return
  }

  if (displayRule.isJs) {
    const styleSettingCode = executeCode(displayRule.jsSetting.styleSettingScript as string, {
      ...scriptData,
    }) as string

    if (!styleSettingCode) {
      return
    }

    return classNamePrefix + styleSettingCode
  }

  const displayRuleValue = displayRule.displayRuleValues.find(item => {
    return item.objectFieldValue === value
  })

  if (displayRuleValue?.styleSetting.code) {
    return classNamePrefix + displayRuleValue?.styleSetting.code
  }
}
